import React, { useEffect, useRef } from 'react';
import './Article.scss';
import { gsap } from './gsap';
import { createPopper } from '@popperjs/core';
import Hero from './Components/Hero/Hero';

import Header from './Components/common-header/Header';
import Footer from './Components/common-footer/Footer';
import InlinePhoto from './Components/Photos/InlinePhoto';
import FullWidthPhoto from './Components/Photos/FullWidthPhoto';
import Chapter1 from './Components/Chapters/Chapter1';
import Chapter2 from './Components/Chapters/Chapter2';
import Chapter3 from './Components/Chapters/Chapter3';
import Chapter4 from './Components/Chapters/Chapter4';
import Chapter5 from './Components/Chapters/Chapter5';
import Chapter6 from './Components/Chapters/Chapter6';
import Chapter7 from './Components/Chapters/Chapter7';
import PullQuoteWImg from './Components/PullQuote/PullQuoteWImg';
import InlineVideo from './Components/Photos/InlineVideo';
// import FullWidthVideo from './Components/Photos/FullWidthVideo';
import contents from './contents';
import RelatedContents from './Components/RelatedContents/RelatedContents';
// import Reference from './Components/Reference/Reference';
import CtaButton from './Components/CtaButton/CtaButton';

//for fullWidth Photos
import fullbleedPhoto1 from './Assets/fullbleedPhoto1.jpg';
import fullbleedPhoto1M from './Assets/fullbleedPhoto1M.jpg';

//pullQuotePhotos
import pqImg1 from './Assets/pqImg1.jpg';
import pqImg2 from './Assets/pqImg2.jpg';

function Article({ heroBackgroundType, inlinePhotoSize, logoPlacement }) {
  //below states are for the audio player placement. See README for detail.

  //create refs for photos here if you want to add scale animation on scroll
  const inline1 = useRef();
  const inline2 = useRef();
  const inline3 = useRef();
  const inline4 = useRef();
  const inline5 = useRef();
  const inline6 = useRef();
  const inline7 = useRef();
  const allPhotosRef = useRef();
  allPhotosRef.current = [inline1, inline2, inline3, inline4, inline5, inline6, inline7]; // put all photo refs in this array

  const screenSizeRef = useRef(); //

  const photoSize = inlinePhotoSize !== undefined ? inlinePhotoSize : contents.inlinePhotos.size;

  //creates/shows tooltip element when mouse enters
  const handleMouseEnterTooltip = (e, currentRef) => {
    const content = currentRef.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  //hides tooltip element when mouse leaves
  const handleMouseLeaveTooltip = (currentRef) => {
    currentRef.current.style.visibility = 'hidden';
  };

  useEffect(() => {
    allPhotosRef.current.forEach((photo) => {
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: photo.current,
          start: '20% bottom',
          end: 'top center',
          scrub: 1
        }
      });
      tl.to(photo.current, {
        width: '100%',
        height: '100%',
        duration: 3
      });
    });
  }, []);

  return (
    <div className="article">
      <div className="height" ref={screenSizeRef} />
      <Header clientName={contents.header} />
      <Hero
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
        heroBackgroundType={heroBackgroundType}
        logoPlacement={logoPlacement}
      />
      <Chapter1 />
      <PullQuoteWImg
        quote={
          '"We’ve been working on different agricultural projects using autonomous air and ground vehicles for the last four years. Our first-hand experience in different locations—from Israel and Europe to North and South America—has shown us just how real those problems are."'
        }
        author={'Alon Ascher'}
        descrip={'Chief Business Officer, Bluewhite'}
        photo={pqImg1}
      />
      {/* <InlineVideo
        vidLink={
          'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/graphicOrbs.mp4'
        }
        vidLinkM={
          'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/graphicOrbsM.mp4'
        }
        caption={
          'A forthcoming high-tech development in quaint Castle Rock, Co., Miller’s Landing boasts frictionless connectivity while retaining the area’s natural charm. Restaurant reservations, work solutions, and even hospital visits can be managed from a smartphone thanks to Intel’s networking capabilities. '
        }
      /> */}

      <Chapter2 />
      <InlinePhoto
        photoSize={photoSize}
        photoContents={contents.inlinePhotos.contents[0]}
        photoRef={inline1}
      />
      <Chapter3 />
      <InlinePhoto
        photoSize={photoSize}
        photoContents={contents.inlinePhotos.contents[1]}
        photoRef={inline2}
      />
      <Chapter4 />
      <InlineVideo
        vidLink={
          'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/blueWhiteCircleInfographic.m4v'
        }
        vidLinkM={
          'https://courageous-cdn-media-bucket.s3.amazonaws.com/intelWonderful/blueWhiteCircleInfographicM.mp4'
        }
        caption={
          'Private wireless and 5G have the potential to revolutionize rural connectivity. In a recent real-world trial, the private network solution achieved high performance across 42 fields covering an area of 2.1 square miles.'
        }
      />

      <Chapter5 />
      <PullQuoteWImg
        quote={
          '“Better decision-making will lead to many things—saving labor, driving sustainability, and generating larger yields. We do believe data will transform the operation”'
        }
        author={'Caroline Chan'}
        descrip={'VP and General Manager of Intel’s Network Business Incubator Division '}
        photo={pqImg2}
      />
      <InlinePhoto
        photoSize={photoSize}
        photoContents={contents.inlinePhotos.contents[3]}
        photoRef={inline4}
      />
      <Chapter6 />

      <FullWidthPhoto
        photo={fullbleedPhoto1}
        photoM={fullbleedPhoto1M}
        alt={'containers'}
        caption={
          'According to Chan, the edge unlocks the full potential of automation technology. “That’s when a tractor becomes a data collection engine, harvesting data that can get digested, analyzed, synthesized and fed back to the farms to drive innovation.” (Photo credit: Bluewhite)'
        }
      />
      <Chapter7 />
      <InlinePhoto
        photoSize={photoSize}
        photoContents={contents.inlinePhotos.contents[4]}
        photoRef={inline5}
      />
      <CtaButton
        handleMouseEnterTooltip={handleMouseEnterTooltip}
        handleMouseLeaveTooltip={handleMouseLeaveTooltip}
      />
      {/* <div className="article__divider" /> */}
      {/* <Reference /> */}
      <RelatedContents />
      <Footer />
    </div>
  );
}

export default Article;
